import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FaTachometerAlt, FaBox, FaCashRegister, FaFileInvoice, FaUser, FaSignOutAlt, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import logo from "../assets/images/logo.png";
import { BsSubstack } from "react-icons/bs";
import { Tooltip } from 'react-tooltip';
import { useSelector } from 'react-redux';

const Sidebar = ({ isOpen, setIsOpen, currentPage }) => {
    const navigate = useNavigate();
    // const storeData = (localStorage.getItem('storeData'));
    // const accountData = JSON.parse(storeData);
    const accountData = useSelector((store) => store?.userReducer?.data);
    const companyName = accountData?.name || "INVETIX POS";

    const menuItems = [
        { name: "Dashboard", path: "/dashboard", icon: <FaTachometerAlt />, id: "dashboard-tooltip" },
        { name: "Products", path: "/products", icon: <FaBox />, id: "products-tooltip" },
        { name: "POS Billing", path: accountData?.business_type === "restaurant" ? "/billing" : "/pos/billing", icon: <FaCashRegister />, id: "billing-tooltip" },
        { name: "Transactions", path: "/transactions", icon: <FaFileInvoice />, id: "transactions-tooltip" },
        { name: "Account", path: "/account", icon: <FaUser />, id: "account-tooltip" },
        { name: "Subscription", path: "/subscriptions", icon: <BsSubstack />, id: "subscription-tooltip" },
    ];

    return (
        <div className={`${isOpen ? "w-60" : "w-16"} bg-gray-800 text-white fixed h-full transition-all duration-300 z-50 flex flex-col`}>
            <div
                className={`flex items-center justify-between cursor-pointer border-b border-r border-white ${!isOpen ? "p-4" : "p-2"}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="text-xl font-bold flex items-center w-full">
                    {isOpen ? (
                        <div className="flex w-full items-center justify-between">
                            <div className="flex gap-3 items-center">
                                <img
                                    src={logo}
                                    alt="Company Logo"
                                    className="object-cover rounded"
                                    style={{ height: '44px', width: '50px' }}
                                />
                                <span title={companyName} className="text-start fs_16 truncate">{companyName?.toLocaleUpperCase()}</span>
                            </div>
                            <FaChevronLeft className="ml-2" />
                        </div>
                    ) : (
                        <div className="flex w-full items-center justify-center my-1">
                            <FaChevronRight />
                        </div>
                    )}
                </span>
            </div>

            <ul className="flex-grow overflow-y-auto mt-2">
                {menuItems.map((item, index) => (
                    <li key={index} onClick={() => setIsOpen(isOpen)}>
                        <NavLink
                            to={item.path}
                            className={`flex items-center p-4 hover:bg-secondary-hover transition-colors ${!isOpen && "justify-center"} ${currentPage === item.name ? 'bg-primary-hover ' : ''}`}
                            activeClassName="bg-blue-900"
                            data-tooltip-id={item.id}
                        >
                            <span className="text-lg" data-tooltip-id={item.id}>{item.icon}</span>
                            {isOpen && <span className="ml-4">{item.name}</span>}
                        </NavLink>

                        {!isOpen && (
                            <Tooltip
                                id={item.id}
                                place="right"
                                effect="solid"

                            >
                                {item.name}
                            </Tooltip>
                        )}
                    </li>
                ))}
            </ul>

            <div className={`pb-10 px-2`}>
                <button
                    className="py-2 px-4 rounded-md flex items-center gap-3 bg-red-600 hover:bg-red-700 text-white"
                    onClick={() => { localStorage.clear(); navigate('/') }}
                    data-tooltip-id="logout-tooltip"
                >
                    <FaSignOutAlt className="inline" />
                    {!isOpen ? '' : 'Logout'}
                </button>

                {!isOpen && (
                    <Tooltip
                        id="logout-tooltip"
                        place="right"
                        effect="solid"
                    >
                        Logout
                    </Tooltip>
                )}
            </div>
        </div>
    );
};

export default Sidebar;
